<template>
  <div>
    <Header title="申请记录"></Header>
    <div class="p_divs">
      <P :style="{ color: color1 }">{{ changeList.auditStateName }}</P>
      <P>{{ changeList.courseName }}</P>
      <P class="p_span"
        >周次：<span>{{ changeList.oldPlanWeek }}</span
        >调课方式：<span>{{ changeList.changeMode }}</span></P
      >
      <P class="p_span"
        >时间：<span>{{ changeList.oldCourseTime }}</span
        >调课类型：<span>{{ changeList.changeTypeName }}</span></P
      >
      <P
        >地点：<span>{{ changeList.oldClassroomName }}</span></P
      >
      <p>
        班级：<span>{{ changeList.className }}</span>
      </p>
    </div>
    <div class="nostop">
      <div v-if="changeList.changeType == '5' ? isHide : isShow">
        <i><img src="../../../assets/images/content_icon2.png" alt=""/></i>
        <span>调课周次</span>
        <input type="text" v-model="oldTimeFlag" class="fr_date" readonly />
      </div>
      <div v-if="changeList.changeType == '5' ? isShow : ''">
        <i><img src="../../../assets/images/icon_teacher2.png" alt=""/></i>
        <span>变更老师</span>
        <input
          type="text"
          class="fr_date"
          readonly
          :value="changeList.teacherName"
        />
      </div>
      <div v-if="changeList.changeType == '2' ? isHide : isShow">
        <i><img src="../../../assets/images/date_icon2.png" alt=""/></i>
        <span>星期几</span>
        <input type="text" class="fr_date" v-model="weekDay" readonly />
      </div>
      <div v-if="changeList.changeType == '2' ? isHide : isShow">
        <i><img src="../../../assets/images/time_icon2.png" alt=""/></i>
        <span>起止节次</span>
        <input
          type="text"
          class="fr_date"
          readonly
          :value="changeList.noteStart + '-' + changeList.noteEnd"
        />
      </div>
      <div v-if="changeList.changeType == '2' ? isHide : isShow">
        <i><img src="../../../assets/images/address_icon2.png" alt=""/></i>
        <span>地点</span>
        <input
          type="text"
          class="fr_date"
          readonly
          :value="changeList.classroomName"
        />
      </div>
      <!-- <div>
				<i><img src="../../../assets/images/icon_people2.png" alt=""></i>
				<span>审核人</span>
				<input type="text" :value="changeList.shr" class="fr_date" readonly>
			</div> -->
      <!--
				<div>
				<i><img src="../../../assets/images/icon_phone2.png" alt=""></i>
				<span>联系电话</span>
				<input type="text" class="fr_date" value="13147029854" readonly>
			</div>
			-->
      <div class="change-res">
        <i><img src="../../../assets/images/icon_why2.png" alt=""/></i>
        <span>调课原因</span>
        <p>{{ changeReason }}</p>
      </div>

      <div v-if="schoolCode == '12607'">
        <i><img src="../../../assets/images/icon_phone2.png" alt=""/></i>
        <span>调课申请单号</span>
        <input
          type="text"
          class="fr_date"
          :value="changeList.tksqdh"
          readonly
        />
      </div>
    </div>
    <van-cell-group inset v-if="schoolCode == '13575'">
      <div class="pg-progress">
        <!-- 审核流程 -->
        <div class="progress-header">
          <span class="progress-header-title">审核流程</span>
        </div>
        <ul class="progress-content">
          <li
            class="progress-content-step"
            v-for="(item, index) in list"
            :key="index"
          >
            <div
              :class="[
                'progress-content-li-left',
                { fail: item.isty === '审核未通过' }
              ]"
            >
              {{ item.seq }}
            </div>
            <ul class="progress-content-li-right">
              <li class="dw-time">
                <span style="font-size: 1rem;color: #333;">
                  操作人：{{ item.shuserrealname }}
                </span>
                <span v-if="item.shsj">{{ item.shsj }}</span>
              </li>
              <li class="person-status" v-if="item.shrolename">
                <span class="shr">节点名称：{{ item.shrolename }}</span>
              </li>
              <li class="remark" v-if="index != 0 && item.shyj">
                {{ item.shyj == "" ? "无" : item.shyj }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      list: [],
      changeList: [],
      changeId: "",
      changeReason: "",
      oldTimeFlag: "",
      color1: "",
      isShow: true,
      isHide: false,
      weekDay: "",
      address: "",
      schoolCode: ""
    };
  },
  methods: {
    async getJstkxxShjl() {
      const res = await Api.getJstkxxShjl({
        changeId: this.$route.query.changeId
      });

      this.list = res.data || [];
    },
    async typeDetail() {
      this.changeId = this.$route.query.changeId;
      const params = {
        changeId: this.changeId
      };
      const res = await Api.teachGetJstkxxDetail(params);
      this.changeList = res.data;
      if (this.changeList.auditStateName == "通过") {
        this.color1 = "#12DDD6";
      } else if (this.changeList.auditStateName == "不通过") {
        this.color1 = "#F86969";
      } else if (this.changeList.auditStateName == "审核中") {
        this.color1 = "#7469F8";
      } else if (this.changeList.auditStateName == "待送审") {
        this.color1 = "#757DA3";
      }
      this.changeReason = res.data.changeReason;
      this.oldTimeFlag = res.data.planWeek;
      this.weekDay = res.data.weekday;
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.typeDetail();
    if (this.schoolCode == "13575") {
      this.getJstkxxShjl();
    }
  }
};
</script>

<style lang="less" scoped>
.pg-progress {
  // padding: 0 .9375rem;
  background-color: #f2f2f2;
  margin-top: 10px;
  border-radius: 8px;
  .pg-gap {
    margin-left: -0.87rem;
    width: calc(100% + 1.74rem);
  }
  .progress-header {
    position: relative;
    text-indent: 11px;
    height: 2.75rem;
    padding: 0 0.9375rem;
    line-height: 2.75rem;
    border-bottom: 1px solid #e5e5e5;
    .progress-header-title {
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0.9375rem;
      top: 14px;
      width: 0.25rem;
      height: 1rem;
      background-color: #7469f8;
      border-radius: 0.125rem;
    }
  }
  .progress-content {
    padding: 20px 0.9375rem 0;
    li {
      position: relative;
      display: flex;
      align-items: flex-start;

      &.progress-content-step {
        &:not(:last-child)::before {
          position: absolute;
          content: "";
          top: 43px;
          left: 18px;
          height: calc(~"100% + 26px - 38px - 10px");
          border: 1px solid #d9d9d9;
        }
        & + li {
          margin-top: 26px;
        }
      }

      .progress-content-li-left {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.625rem;
        height: 2.625rem;
        background-color: #7469f8;
        border-radius: 4px;
        margin-right: 14px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: right;
        line-height: 14px;

        &.fail {
          background: red;
        }
      }
      .progress-content-li-right {
        flex: 1;
        li {
          margin-bottom: 12px;
          justify-content: space-between;
          &.dw-time {
            display: flex;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #999;
            letter-spacing: 0;
            line-height: 16px;
          }
          &.person-status {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #666;
            letter-spacing: 0;
            line-height: 16px;
            .status {
              font-size: 0.875rem;
            }
            .shr {
              width: 100%;
              word-break: break-all;
            }
          }
          &.remark {
            padding: 10px;
            background: #fff;
            border-radius: 4px;

            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            line-height: 20px;
          }
        }
      }
    }
  }
}
.change-res {
  display: flex;
}
.change-res > p {
  color: @attendance-color-1;
  font-weight: 700;
  flex: 1;
  margin-left: 20px;
}
.p_divs {
  width: 90%;
  margin-left: 5%;
  margin-top: 70px;
}
.p_divs > p {
  color: @attendance-color-2;
  font-size: 14px;
  margin-top: 8px;
}
.p_divs > p:nth-child(1) {
  font-weight: 700;
  font-size: 24px;
  margin: 20px 0;
}
.p_divs > p:nth-child(2) {
  color: @attendance-color-1;
  font-weight: 700;
  font-size: 18px;
}
.p_divs > p span {
  font-weight: 600;
}
.p_divs .p_span span {
  /* margin-right: 30px; */
  width: 80px;
  display: inline-block;
}
.p_divs .p_content span:nth-child(1) {
  float: left;
}
.p_divs .p_content span:nth-child(2) {
  /* display: inline-block; */
  width: 294px;
  height: 40px;
}
.nostop {
  width: 90%;
  margin-left: 5%;
}
.nostop > div {
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  border-bottom: 1px solid #f4f4f4;
}
.nostop > div span {
  color: @attendance-color-1;
  font-size: 16px;
}
.nostop > div i {
  display: inline-block;
  width: 22px;
  height: 22px;
}
.nostop > div i img {
  width: 100%;
  vertical-align: middle;
}
.fr_date {
  float: right;
  /* width: 110px; */
  height: 40px;
  text-align: right;
  border: none !important;
  color: @attendance-color-1;
  font-size: 16px;
}
.nostop > div input::-webkit-input-placeholder {
  text-align: right;
  color: #dfe0e6;
  font-size: 16px;
}
.nostop > div textarea {
  font-weight: 700;
  text-align: right;
  float: right;
  height: 88px;
  width: 205px;
  border: none;
  outline: none;
  color: @attendance-color-1;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Change/noStop.vue